/**
 * @generated SignedSource<<6b3db0f09dbc75d7dd3be138c4a1d11c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "removeByEmailInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveByEmailInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveByEmailInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3bf06b5b83eea10e883e0f1a842bda9f",
    "id": null,
    "metadata": {},
    "name": "RemoveByEmailInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveByEmailInvitationMutation(\n  $email: String!\n) {\n  removeByEmailInvitation(email: $email) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "340f88584f0fa388e172ab24791b5df7";

export default node;
